import SelectableCard from 'core/components/SelectableCard'
import Text from 'core/elements/Text'
import { humanReadableSize } from 'openstack/helpers'
import { durationBetweenDates } from 'utils/misc'
import useCreateVirtualMachineModalStyles from '../CreateVirtualMachineModal.styles'
import { isImageCompatibleWithVolumeAndFlavor } from '../helpers'

interface Props {
  item: any
  params: any
  updateParams: (value: any) => void
}

export default function SourceImageCard({ item, params, updateParams }: Props) {
  const classes = useCreateVirtualMachineModalStyles()
  const disabled = isImageCompatibleWithVolumeAndFlavor(item, params)

  return (
    <SelectableCard
      id={item}
      onClick={(selectedImage) =>
        updateParams({
          image: [selectedImage],
        })
      }
      tooltip={
        disabled ? 'Image is not compatible with the selected flavor and volume size.' : undefined
      }
      active={params.image?.[0]?.id === item.id}
      className={classes.card}
      disabled={disabled}
      withCustomBody
      showRadioButton
    >
      <Text variant="body2" className={classes.cardHeader}>
        <b>{item.name}</b>
      </Text>
      <div className={classes.pairs}>
        <Text variant="body2" className={classes.cardText}>
          Format: <b>{item?.disk_format}</b>
        </Text>
        <Text variant="body2" className={classes.cardText}>
          Virtual Size:{' '}
          <b>
            {item?.virtual_size ? humanReadableSize(item?.virtual_size) : 'N/A'}
            {disabled && ' (Too Large)'}
          </b>
        </Text>
        <Text variant="body2" className={classes.cardText}>
          Age:{' '}
          <b>
            {item?.created_at &&
              durationBetweenDates({
                labels: ['d'],
              })(item?.created_at)}
          </b>
        </Text>
      </div>
    </SelectableCard>
  )
}
